/* Tonies BYOB dispatch dates.
   Product cards, the bundle summary, and the add-to-cart payload read the
   short lead-time-label copy. In-stock variants have no line. */
(function (root) {
  'use strict';

  var CACHE_MS = 10 * 60 * 1000;
  var state = {
    labels: {},
    ready: false
  };

  function plainLabel(html) {
    return String(html || '')
      .replace(/<\/?sup>/gi, '')
      .replace(/<[^>]+>/g, '')
      .replace(/&amp;/g, '&')
      .replace(/&lt;/g, '<')
      .replace(/&gt;/g, '>')
      .replace(/&#39;/g, "'")
      .replace(/&quot;/g, '"')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function optionKey(raw) {
    return String(raw || '')
      .replace(/\s*<>\s*/g, ' / ')
      .trim();
  }

  function dispatchValue(variants, labels) {
    var lines = [];
    (variants || []).forEach(function (variant) {
      if (!variant) return;
      var label = plainLabel(labels[String(variant.id)]);
      if (!label) return;
      var title = variant.productTitle || 'Item';
      lines.push(title + ' — ' + label);
    });
    return lines.join('\n');
  }

  function withPage(url, page) {
    var join = url.indexOf('?') === -1 ? '?' : '&';
    return url + join + 'page=' + page;
  }

  function readJson(response) {
    return response.text().then(function (text) {
      var start = text.indexOf('{');
      var end = text.lastIndexOf('}');
      if (start < 0 || end < start) {
        throw new Error('Lead times response was empty');
      }
      return JSON.parse(text.slice(start, end + 1));
    });
  }

  function cacheKey(url) {
    return 'nbs-byob-lead:v3:' + url;
  }

  function readCache(url) {
    try {
      var raw = root.sessionStorage.getItem(cacheKey(url));
      if (!raw) return null;
      var parsed = JSON.parse(raw);
      if (!parsed || !parsed.at || Date.now() - parsed.at > CACHE_MS) return null;
      return parsed.variants || null;
    } catch (err) {
      return null;
    }
  }

  function writeCache(url, variants) {
    try {
      root.sessionStorage.setItem(cacheKey(url), JSON.stringify({
        at: Date.now(),
        variants: variants
      }));
    } catch (err) {
      /* Private mode and full storage can reject the write. */
    }
  }

  function loadLabels(url, onUpdate) {
    var cached = readCache(url);
    if (cached) {
      if (onUpdate) onUpdate(cached);
      return Promise.resolve(cached);
    }

    function take(data, merged) {
      Object.assign(merged, (data && data.variants) || {});
      if (onUpdate) onUpdate(merged);
    }

    return fetch(withPage(url, 1), { credentials: 'same-origin' })
      .then(readJson)
      .then(function (first) {
        var merged = {};
        take(first, merged);
        var pages = Math.min((first && first.pages) || 1, 40);
        if (pages < 2) {
          writeCache(url, merged);
          return merged;
        }
        var jobs = [];
        for (var page = 2; page <= pages; page++) {
          jobs.push(
            fetch(withPage(url, page), { credentials: 'same-origin' })
              .then(readJson)
              .then(function (data) { take(data, merged); })
              .catch(function () {})
          );
        }
        return Promise.all(jobs).then(function () {
          writeCache(url, merged);
          return merged;
        });
      });
  }

  function productLeadUrl(productUrl) {
    var path = String(productUrl || '').split('?')[0];
    if (!path) return '';
    var join = path.indexOf('?') === -1 ? '?' : '&';
    return path + join + 'view=lead';
  }

  function placeLabel(host, label) {
    if (!host) return;
    var slot = host.querySelector(':scope > [data-byob-lead]');
    if (!label) {
      if (slot) slot.remove();
      return;
    }
    if (!slot) {
      slot = document.createElement('div');
      slot.setAttribute('data-byob-lead', '');
      host.appendChild(slot);
    }
    var anchor = host.querySelector(':scope > .byob-nbs-oos') || host.querySelector(
      ':scope > .byob-bundle__product-card-title, :scope > .byob-resource__title, :scope > .byob-bundle__product-card-price, :scope > .byob-options-modal__price'
    );
    if (anchor && slot.previousElementSibling !== anchor) {
      anchor.insertAdjacentElement('afterend', slot);
    }
    if (slot.getAttribute('data-label') !== label) {
      slot.innerHTML = label;
      slot.setAttribute('data-label', label);
    }
  }

  function variantsNamed(title) {
    var nodes = [];
    document.querySelectorAll('byob-variant').forEach(function (node) {
      if ((node.getAttribute('product-title') || '') === title) nodes.push(node);
    });
    return nodes;
  }

  /* A chosen size uses that variant's label only. In stock means no line.
     The old product-level fallback stored the last sold-out sibling, so
     Candy Pink 3-5y showed "Sold out" from 0-2y or 6y+. */
  function labelForChoice(title, option) {
    var wanted = optionKey(option);
    var nodes = variantsNamed(title);
    if (wanted && wanted !== 'Default Title') {
      for (var i = 0; i < nodes.length; i++) {
        if (optionKey(nodes[i].getAttribute('option-values')) === wanted) {
          return state.labels[nodes[i].getAttribute('variant-id')] || '';
        }
      }
      return '';
    }
    if (nodes.length === 1) return state.labels[nodes[0].getAttribute('variant-id')] || '';
    var inStock = nodes.some(function (node) {
      return !state.labels[node.getAttribute('variant-id')];
    });
    if (nodes.length && !inStock) return state.labels[nodes[0].getAttribute('variant-id')] || '';
    return '';
  }

  /* The picker card speaks for the product. A label appears only when
     every size is unavailable. One available size leaves the card clear,
     and the size sheet carries the sold-out sizes. A single-variant
     product, including a Tonie, still uses that variant's own line. */
  function cardLabel(card) {
    var titleEl = card.querySelector('.byob-bundle__product-card-title-text');
    var title = titleEl ? titleEl.textContent.trim() : '';
    var nodes = variantsNamed(title);
    if (nodes.length > 1) {
      var allUnavailable = nodes.every(function (node) {
        return node.getAttribute('available') === 'false';
      });
      if (!allUnavailable) return '';
      for (var i = 0; i < nodes.length; i++) {
        var line = state.labels[nodes[i].getAttribute('variant-id')];
        if (line) return line;
      }
      return '';
    }
    var select = card.querySelector('select.byob-bundle__product-variant-select');
    if (select && select.value) {
      if (state.labels[String(select.value)]) return state.labels[String(select.value)];
      return labelForChoice(title, select.value);
    }

    var pressed = card.querySelector('.byob-swatch[aria-pressed="true"]');
    if (pressed) {
      return labelForChoice(title, (pressed.getAttribute('aria-label') || '').trim());
    }

    var single = card.querySelector('.byob-bundle__product-variant-single');
    if (single) {
      var option = single.textContent.trim();
      if (option && option !== 'Default Title') return labelForChoice(title, option);
    }

    return labelForChoice(title, '');
  }

  function paint() {
    // The grid paints byob-product-picker-card next to the server
    // byob-product nodes, so the date is not inside byob-product.
    document.querySelectorAll('byob-product-picker-card').forEach(function (card) {
      var label = cardLabel(card);
      placeLabel(card.querySelector('.byob-bundle__product-card-meta'), label);
      placeLabel(card.querySelector('.byob-options-modal__content'), label);
    });

    document.querySelectorAll('.byob-resource').forEach(function (row) {
      var titleEl = row.querySelector('.byob-resource__title');
      if (!titleEl) return;
      var title = (titleEl.dataset && titleEl.dataset.nbsOriginal) || titleEl.textContent.trim();
      var optionEl = row.querySelector('.byob-resource__variant');
      var options = optionEl ? optionEl.textContent.trim() : '';
      if (/^default title$/i.test(options)) options = '';
      placeLabel(row.querySelector('.byob-resource__body'), labelForChoice(title, options));
    });
  }

  function missingProductUrls() {
    var urls = {};
    document.querySelectorAll('byob-variant').forEach(function (node) {
      var id = node.getAttribute('variant-id');
      if (!id || state.labels[id]) return;
      var url = productLeadUrl(node.getAttribute('product-url'));
      if (url) urls[url] = true;
    });
    return Object.keys(urls);
  }

  function loadMissing(urls) {
    var pending = urls.slice();
    var workers = [];
    var concurrency = 4;

    function next() {
      var url = pending.shift();
      if (!url) return Promise.resolve();
      return fetch(url, { credentials: 'same-origin' })
        .then(readJson)
        .then(function (data) {
          Object.assign(state.labels, (data && data.variants) || {});
          if (state.ready) paint();
        })
        .catch(function () {})
        .then(next);
    }

    for (var i = 0; i < concurrency; i++) workers.push(next());
    return Promise.all(workers);
  }

  function attachDispatch(event) {
    var detail = event.detail || {};
    var items = detail.items;
    if (!items || !items.length) return;
    var value = dispatchValue(detail.selectedVariants, state.labels);
    if (!value) return;
    var item = items[0];
    var attrs = item.attributes || (item.attributes = []);
    var existing = null;
    for (var i = 0; i < attrs.length; i++) {
      if (attrs[i] && attrs[i].key === 'Dispatch') existing = attrs[i];
    }
    if (existing) existing.value = value;
    else attrs.push({ key: 'Dispatch', value: value });
  }

  function boot() {
    if (root.__nbsByobLead) return;
    var config = document.getElementById('ByobLeadTimes');
    if (!config) return;
    root.__nbsByobLead = true;

    document.addEventListener('simple-bundles-byob:add-to-cart', attachDispatch, true);

    var rootEl = document.getElementById('byob-app-embed-wrapper');
    if (rootEl && 'MutationObserver' in root) {
      var timer = 0;
      var observer = new MutationObserver(function () {
        if (!state.ready) return;
        root.clearTimeout(timer);
        timer = root.setTimeout(paint, 40);
      });
      observer.observe(rootEl, { childList: true, subtree: true, attributes: true, attributeFilter: ['aria-pressed'] });
    }
    document.addEventListener('change', function (event) {
      if (event.target && event.target.closest && event.target.closest('#byob-app-embed-wrapper')) paint();
    });

    var url = config.getAttribute('data-collection-url');
    function show(labels) {
      if (labels) state.labels = labels;
      state.ready = true;
      paint();
    }

    /* Paint as soon as the first collection page arrives. The rest of the
       Tonies pages run together, and each one fills in more dates. */
    loadLabels(url, show)
      .then(function () {
        return loadMissing(missingProductUrls());
      })
      .then(paint)
      .catch(function () {
        paint();
      });
  }

  root.NbsByobLead = {
    plainLabel: plainLabel,
    optionKey: optionKey,
    dispatchValue: dispatchValue,
    paint: paint,
    state: state
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})(window);
